// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/**
 * 获取企业假期管理配置
 * @description 获取企业配置的所有假期类型
 * @returns Promise<OA.ApiResponse<OA.VacationCorpConfData>>
 */
export async function getVacationCorpConf(options?: Record<string, any>) {
  return request<OA.ApiResponse<OA.VacationCorpConfData>>('/api/v1/wechat/vacation/corp-conf', {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 获取成员假期余额
 * @description 查询指定成员的假期余额情况
 * @param data 包含userid的请求参数
 * @returns Promise<OA.ApiResponse<OA.VacationUserQuotaData>>
 */
export async function getVacationUserQuota(
  data: OA.VacationUserQuotaParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.VacationUserQuotaData>>('/api/v1/wechat/vacation/user-quota', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 修改成员假期余额
 * @description 修改指定成员的假期余额（单个假期类型）
 * 注意：
 * - 系统会自动将明文userid转换为wechat_open_userid后调用企业微信API
 * - leftduration是修改后的总剩余时长，不是增量！
 * - leftduration限制：不能大于1000天或24000小时
 * - 按小时请假时，leftduration必须为360整倍数（即0.1小时整倍数）
 * - 按天请假时，leftduration必须为8640整倍数（即0.1天整倍数）
 * - time_attr必须等于企业假期管理配置中设置的假期时间刻度类型
 * @param data 包含userid、vacation_id、leftduration、time_attr和remarks的请求参数
 * @returns Promise<OA.ApiResponse<OA.VacationModifyQuotaResult>>
 */
export async function modifyVacationQuota(
  data: OA.VacationModifyQuotaParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.VacationModifyQuotaResult>>('/api/v1/wechat/vacation/modify-quota', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取用户假期列表
 * @description 分页查询企业微信同步的用户列表，并为每个用户补充假期余额信息
 * @param params 分页参数
 * @returns Promise<OA.ApiResponse<OA.VacationUserListData>>
 */
export async function getVacationUserList(
  params?: OA.VacationUserListParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.VacationUserListData>>('/api/v1/wechat/vacation/user-list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 设置假期有效期
 * @description 设置或更新用户假期的有效期
 * @param data 包含user_id、vacation_id、vacation_name、expiry_date和remarks的请求参数
 * @returns Promise<OA.ApiResponse<OA.SetVacationExpiryResult>>
 */
export async function setVacationExpiry(
  data: OA.SetVacationExpiryParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.SetVacationExpiryResult>>('/api/v1/wechat/vacation/expiry/set', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取假期有效期列表
 * @description 分页查询假期有效期记录
 * @param params 分页和筛选参数
 * @returns Promise<OA.ApiResponse<OA.VacationExpiryListData>>
 */
export async function getVacationExpiryList(
  params?: OA.VacationExpiryListParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.VacationExpiryListData>>('/api/v1/wechat/vacation/expiry/list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 设置假期额度配置
 * @description 为指定用户的指定假期类型设置额度配置
 * @param data 包含user_id、vacation_id、vacation_name、quota_days和remarks的请求参数
 * @returns Promise<OA.ApiResponse<OA.SetVacationQuotaConfigResult>>
 */
export async function setVacationQuotaConfig(
  data: OA.SetVacationQuotaConfigParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.SetVacationQuotaConfigResult>>('/api/v1/wechat/vacation/quota/set', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取假期额度配置列表
 * @description 分页查询假期额度配置记录
 * @param params 分页和筛选参数
 * @returns Promise<OA.ApiResponse<OA.VacationQuotaConfigListData>>
 */
export async function getVacationQuotaConfigList(
  params?: OA.VacationQuotaConfigListParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.VacationQuotaConfigListData>>('/api/v1/wechat/vacation/quota/list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 设置假期类型级别有效期
 * @description 设置或更新假期类型的有效期规则（针对整个假期类型）
 * @param data 包含vacation_id、vacation_name、expiry_month、expiry_day、is_active和remarks的请求参数
 * @returns Promise<OA.ApiResponse<OA.SetVacationTypeExpiryResult>>
 */
export async function setVacationTypeExpiry(
  data: OA.SetVacationTypeExpiryParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.SetVacationTypeExpiryResult>>('/api/v1/wechat/vacation/type-expiry/set', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取假期类型级别有效期列表
 * @description 分页查询假期类型有效期配置记录
 * @param params 分页和筛选参数
 * @returns Promise<OA.ApiResponse<OA.VacationTypeExpiryListData>>
 */
export async function getVacationTypeExpiryList(
  params?: OA.VacationTypeExpiryListParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.VacationTypeExpiryListData>>('/api/v1/wechat/vacation/type-expiry/list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 获取假期类型级别有效期详情
 * @description 获取指定ID的假期类型有效期配置详情
 * @param expiryId 有效期配置记录ID
 * @returns Promise<OA.ApiResponse<OA.VacationTypeExpiryRecord>>
 */
export async function getVacationTypeExpiryDetail(
  expiryId: number,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.VacationTypeExpiryRecord>>(`/api/v1/wechat/vacation/type-expiry/${expiryId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 更新假期类型级别有效期
 * @description 更新指定ID的假期类型有效期配置
 * @param expiryId 有效期配置记录ID
 * @param data 包含expiry_month、expiry_day、is_active和remarks的请求参数
 * @returns Promise<OA.ApiResponse<any>>
 */
export async function updateVacationTypeExpiry(
  expiryId: number,
  data: OA.UpdateVacationTypeExpiryParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<any>>(`/api/v1/wechat/vacation/type-expiry/${expiryId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除假期类型级别有效期
 * @description 删除指定ID的假期类型有效期配置
 * @param expiryId 有效期配置记录ID
 * @returns Promise<OA.ApiResponse<any>>
 */
export async function deleteVacationTypeExpiry(
  expiryId: number,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<any>>(`/api/v1/wechat/vacation/type-expiry/${expiryId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/**
 * 创建育儿假配置
 * @description 为指定用户创建一个育儿假发放配置，创建成功后会立即触发一次发放检查
 * @param data 包含user_id、start_date、end_date、grant_days和remarks的请求参数
 * @returns Promise<OA.ApiResponse<{id: number}>>
 */
export async function createParentalLeaveConfig(
  data: OA.CreateParentalLeaveConfigParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<{ id: number }>>('/api/v1/wechat/parental-leave/config/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 批量创建育儿假配置
 * @description 为一个用户一次性创建多个日期区间的配置，创建成功后会立即触发一次发放检查
 * @param data 包含user_id和configs的请求参数
 * @returns Promise<OA.ApiResponse<OA.BatchCreateParentalLeaveConfigResult>>
 */
export async function batchCreateParentalLeaveConfig(
  data: OA.BatchCreateParentalLeaveConfigParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.BatchCreateParentalLeaveConfigResult>>('/api/v1/wechat/parental-leave/config/batch-create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取育儿假配置列表
 * @description 查询所有育儿假配置记录，支持分页和筛选
 * @param params 分页和筛选参数
 * @returns Promise<OA.ApiResponse<OA.ParentalLeaveConfigListData>>
 */
export async function getParentalLeaveConfigList(
  params?: OA.ParentalLeaveConfigListParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.ParentalLeaveConfigListData>>('/api/v1/wechat/parental-leave/config/list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 获取育儿假配置详情
 * @description 根据配置ID获取详细信息
 * @param configId 配置记录ID
 * @returns Promise<OA.ApiResponse<OA.ParentalLeaveConfig>>
 */
export async function getParentalLeaveConfigDetail(
  configId: number,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.ParentalLeaveConfig>>(`/api/v1/wechat/parental-leave/config/${configId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 更新育儿假配置
 * @description 更新指定的育儿假配置
 * @param configId 配置记录ID
 * @param data 包含grant_days、is_active和remarks的请求参数
 * @returns Promise<OA.ApiResponse<any>>
 */
export async function updateParentalLeaveConfig(
  configId: number,
  data: OA.UpdateParentalLeaveConfigParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<any>>(`/api/v1/wechat/parental-leave/config/${configId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除育儿假配置
 * @description 删除指定的育儿假配置（会级联删除相关的发放历史记录）
 * @param configId 配置记录ID
 * @returns Promise<OA.ApiResponse<any>>
 */
export async function deleteParentalLeaveConfig(
  configId: number,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<any>>(`/api/v1/wechat/parental-leave/config/${configId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/**
 * 获取育儿假发放历史列表
 * @description 查询育儿假发放历史记录，支持分页和筛选
 * @param params 分页和筛选参数
 * @returns Promise<OA.ApiResponse<OA.ParentalLeaveHistoryListData>>
 */
export async function getParentalLeaveHistoryList(
  params?: OA.ParentalLeaveHistoryListParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.ParentalLeaveHistoryListData>>('/api/v1/wechat/parental-leave/history/list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 获取待销假提醒记录列表
 * @description 查询待销假的提醒记录列表
 * @returns Promise<OA.ApiResponse<OA.PendingCancellationRemindersData>>
 */
export async function getPendingCancellationReminders(
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.PendingCancellationRemindersData>>('/api/v1/wechat/vacation/pending-cancellation-reminders', {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 重新发送销假提醒
 * @description 重新发送所有待销假提醒
 * @returns Promise<OA.ApiResponse<OA.ResendCancellationRemindersResult>>
 */
export async function resendCancellationReminders(
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.ResendCancellationRemindersResult>>('/api/v1/wechat/vacation/resend-cancellation-reminders', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    ...(options || {}),
  });
}

// ==================== 年度假期额度相关接口 ====================

/**
 * 设置年度假期额度
 * @description 为指定用户的指定假期类型设置指定年份的额度
 * @param data 包含user_id、vacation_id、vacation_name、quota_year、quota_days和remarks的请求参数
 * @returns Promise<OA.ApiResponse<OA.SetYearlyQuotaResult>>
 */
export async function setYearlyQuota(
  data: OA.SetYearlyQuotaParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.SetYearlyQuotaResult>>('/api/v1/wechat/vacation/yearly-quota/set', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 批量设置年度假期额度
 * @description 为多个用户批量设置相同的年度额度
 * @param data 包含user_ids、vacation_id、vacation_name、quota_year、quota_days和remarks的请求参数
 * @returns Promise<OA.ApiResponse<OA.BatchSetYearlyQuotaResult>>
 */
export async function batchSetYearlyQuota(
  data: OA.BatchSetYearlyQuotaParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.BatchSetYearlyQuotaResult>>('/api/v1/wechat/vacation/yearly-quota/batch-set', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 复制年度额度到新年份
 * @description 将某年的额度配置复制到新的一年
 * @param data 包含vacation_id、source_year、target_year和quota_days_override的请求参数
 * @returns Promise<OA.ApiResponse<OA.CopyYearlyQuotaResult>>
 */
export async function copyYearlyQuota(
  data: OA.CopyYearlyQuotaParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.CopyYearlyQuotaResult>>('/api/v1/wechat/vacation/yearly-quota/copy', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取年度假期额度列表
 * @description 分页查询年度假期额度记录
 * @param params 分页和筛选参数
 * @returns Promise<OA.ApiResponse<OA.YearlyQuotaListData>>
 */
export async function getYearlyQuotaList(
  params?: OA.YearlyQuotaListParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.YearlyQuotaListData>>('/api/v1/wechat/vacation/yearly-quota/list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 获取年度假期额度详情
 * @description 获取指定ID的年度假期额度详情
 * @param quotaId 额度配置记录ID
 * @returns Promise<OA.ApiResponse<OA.YearlyQuotaRecord>>
 */
export async function getYearlyQuotaDetail(
  quotaId: number,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.YearlyQuotaRecord>>(`/api/v1/wechat/vacation/yearly-quota/${quotaId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 获取用户的年度假期额度
 * @description 获取指定用户的年度假期额度列表
 * @param userId 用户ID
 * @param params 可选的年份筛选参数
 * @returns Promise<OA.ApiResponse<OA.UserYearlyQuota[]>>
 */
export async function getUserYearlyQuota(
  userId: number,
  params?: { quota_year?: number },
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.UserYearlyQuota[]>>(`/api/v1/wechat/vacation/yearly-quota/user/${userId}`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 更新年度假期额度
 * @description 更新指定ID的年度假期额度
 * @param quotaId 额度配置记录ID
 * @param data 包含quota_days和remarks的请求参数
 * @returns Promise<OA.ApiResponse<any>>
 */
export async function updateYearlyQuota(
  quotaId: number,
  data: OA.UpdateYearlyQuotaParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<any>>(`/api/v1/wechat/vacation/yearly-quota/${quotaId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除年度假期额度
 * @description 删除指定ID的年度假期额度
 * @param quotaId 额度配置记录ID
 * @returns Promise<OA.ApiResponse<any>>
 */
export async function deleteYearlyQuota(
  quotaId: number,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<any>>(`/api/v1/wechat/vacation/yearly-quota/${quotaId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/**
 * 从CSV导入年度假期额度
 * @description 通过CSV文件批量导入年度假期额度
 * @param file CSV文件
 * @param updateBalance 是否同时更新企业微信假期余额，默认true
 * @returns Promise<OA.ApiResponse<OA.ImportYearlyQuotaResult>>
 */
export async function importYearlyQuotaFromCSV(
  file: File,
  updateBalance: boolean = true,
  options?: Record<string, any>
) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('update_balance', String(updateBalance));

  return request<OA.ApiResponse<OA.ImportYearlyQuotaResult>>('/api/v1/wechat/vacation/yearly-quota/import', {
    method: 'POST',
    data: formData,
    requestType: 'form',
    ...(options || {}),
  });
}

// ==================== 请假申请相关接口 ====================

/**
 * 获取请假申请列表
 * @description 分页查询请假申请记录
 * @param params 分页和筛选参数
 * @returns Promise<OA.ApiResponse<OA.LeaveApplicationListData>>
 */
export async function getLeaveApplicationList(
  params?: OA.LeaveApplicationListParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.LeaveApplicationListData>>('/api/v1/wechat/vacation/leave-applications', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

